@use "../../../../../../node_modules/bulma/sass/utilities/mixins.sass" as mixins;

.summary-width {
    @include mixins.desktop {
        max-width: 400px;
    }
}